import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import BaseMixer from "../../BaseMixer";
import { IDetailedNotificationDTO } from "@/store/models/notification/DetailedNotification";
import { NotificationsModule } from "@/store/modules/notification.module";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let AcceptedProjectRequestComponent = /** @class */ (() => {
    var _a;
    let AcceptedProjectRequestComponent = class AcceptedProjectRequestComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.tenantId = localStorage.getItem("tenantId");
        }
        UpdateIsActive(notification) {
            if (!notification.isComplete) {
                return; // do nothing
            }
            this.$router.push({ name: "ProjectOverview", params: { projectId: this.notificationDetails.projectId } });
            NotificationsModule.UpdateIsActive(notification.id);
        }
        UpdateIsSeen() {
            NotificationsModule.UpdateIsSeen(this.notification.id);
        }
        get notificationDetails() {
            return this.notification.notificationData;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IDetailedNotificationDTO !== "undefined" && IDetailedNotificationDTO) === "function" ? _a : Object)
    ], AcceptedProjectRequestComponent.prototype, "notification", void 0);
    AcceptedProjectRequestComponent = __decorate([
        Component({
            name: "AcceptedProjectRequestComponent",
            components: {},
        })
    ], AcceptedProjectRequestComponent);
    return AcceptedProjectRequestComponent;
})();
export default AcceptedProjectRequestComponent;
